import type { IconDefinition } from '../index.tsx';

export const iconArrowRight: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconArrowRight',
  icon: [
    16,
    16,
    [],
    '',
    'M8 6L8 2L10 2L16 8L10 14L8 14L8 10L-1.74845e-07 10L-3.01991e-07 6L8 6Z',
  ],
};
